export const formatDayDateToApi = (date: Date | null) => {
    if (!date) return '';
    const dateStr = date.toLocaleDateString();
    return dateStr.replace(/\./g, '-');
};
